import React from 'react';
import { Alert, Box, Typography } from '@mui/material';

export const hasVerificationWarnings = (warnings) => Array.isArray(warnings)
  && warnings.some((item) => typeof item?.reason === 'string' && item.reason.trim()
    && typeof item?.uncertainty === 'string' && item.uncertainty.trim());

const readExpanded = (key) => {
  try { return key ? sessionStorage.getItem(key) === 'true' : false; } catch { return false; }
};

const WidgetVerificationNotice = ({ warnings, widgetId, t }) => {
  const storageKey = widgetId == null ? null : `widget-verification-details:${widgetId}`;
  const [expanded, setExpanded] = React.useState(() => readExpanded(storageKey));
  React.useEffect(() => { setExpanded(readExpanded(storageKey)); }, [storageKey]);
  if (!hasVerificationWarnings(warnings)) return null;
  const translate = (key, defaultValue) => (typeof t === 'function' ? t(key, { defaultValue }) : defaultValue);
  const items = warnings.filter((item) => typeof item?.reason === 'string' && item.reason.trim()
    && typeof item?.uncertainty === 'string' && item.uncertainty.trim()).slice(0, 128);

  return (
    <Alert severity="warning" sx={{ mb: 1, flexShrink: 0 }}>
      <Typography variant="body2" fontWeight={600}>
        {translate('widget.verification_warning_title', 'Check this result')}
      </Typography>
      {translate('widget.verification_warning_message', 'A result was selected from the sources, but some points remain uncertain.')}
      <Box component="details" open={expanded} onToggle={(event) => {
        const open = event.currentTarget.open;
        setExpanded(open);
        try { if (storageKey) sessionStorage.setItem(storageKey, String(open)); } catch {
          // Keep the choice in component state when browser storage is unavailable.
        }
      }} sx={{ mt: 0.5 }}>
        <Box component="summary" sx={{ cursor: 'pointer' }}>
          {translate('widget.verification_warning_details', 'See decisions and uncertainties')}
        </Box>
        <Box component="ul" sx={{ pl: 2, my: 0.5 }}>
          {items.map((item, index) => (
            <li key={item.id || index}>
              {typeof item.label === 'string' && <strong>{item.label.slice(0, 300)}: </strong>}
              {item.reason.slice(0, 2000)}{' '}{item.uncertainty.slice(0, 2000)}
            </li>
          ))}
        </Box>
      </Box>
    </Alert>
  );
};

export default WidgetVerificationNotice;
